import React from 'react';
import {Apple, CloudFill, Windows} from "react-bootstrap-icons";

/**
 * Renders an OS-specific icon based on the provided platform name string.
 *
 * - Names starting with `"MacOS"` → Apple icon (24 px)
 * - Names starting with `"Windows"` → Windows icon (24 px)
 * - Names starting with `"web-app"` → CloudFill icon (24 px)
 * - `undefined` or unrecognised strings → renders nothing
 *
 * @param name - The platform/OS identifier string (e.g. `"MacOS 12"`, `"Windows 10"`, `"web-app"`).
 */
export default function OsIcon({ name }: { name?: string | undefined }) {
    return typeof name === 'string' ? (
        <>
            {name.indexOf('MacOS') === 0 && <Apple size={24} />}
            {name.indexOf('Windows') === 0 && <Windows size={24} />}
            {name.indexOf('web-app') === 0 && <CloudFill size={24} />}
        </>
    ) : null;
}
